module.exports = __webpack_public_path__ + "static/media/strip-mobile-rocketeer-desk.abfc8606.png";